import { render, staticRenderFns } from "./TaskActionButtons.vue?vue&type=template&id=a1d657ac&scoped=true"
import script from "./TaskActionButtons.vue?vue&type=script&lang=js"
export * from "./TaskActionButtons.vue?vue&type=script&lang=js"
import style0 from "./TaskActionButtons.vue?vue&type=style&index=0&id=a1d657ac&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d657ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
